import { STATES } from '../../../../constants';
import { isFeatureEnabled } from '@updater-core/lib/optimizely';

const verifyCodeStateName = (baseName) => `${baseName}.phone.code`;

export function VerifyPhoneCodeConfig($stateProvider) {
  'ngInject';
  $stateProvider
    .state(verifyCodeStateName(STATES.VERIFY), getSendCodeState())
    .state(verifyCodeStateName(STATES.MOVES_VERIFY), getSendCodeState())
    .state(
      verifyCodeStateName(STATES.STEP_FORWARD_MAIL_VERIFY),
      getSendCodeState({ fym: true })
    )
    .state(
      verifyCodeStateName(STATES.STEP_UPDATE_ACCOUNTS_VERIFY),
      getSendCodeState()
    );

  function getSendCodeState({ fym } = {}) {
    return {
      url: '/send-code?phone_number?delivery_method',
      views: {
        '@': {
          // template:
          // '<upd-verify-phone-code origin="ctrl.origin"></upd-verify-phone-code>',
          template: () => {
            if (!fym) {
              return '<upd-verify-phone-code origin="ctrl.origin"></upd-verify-phone-code>';
            }
            return isFeatureEnabled('fym_reskin').then((enabled) =>
              enabled
                ? '<uds-verify-phone-code class="uds" origin="ctrl.origin"></uds-verify-phone-code>'
                : '<upd-verify-phone-code origin="ctrl.origin"></upd-verify-phone-code>'
            );
          },
          controller,
          controllerAs: 'ctrl',
        },
      },
      scrollTop: true,
      analytics: {
        page: 'Verify Send Code',
      },
      onEnter: function ($state, origin) {
        'ngInject';
        this.titleBar = ($state.get(origin) || {}).titleBar;
      },
    };
  }
}

function controller(origin) {
  'ngInject';
  this.origin = origin;
}
